module.exports = __webpack_public_path__ + "img/company11.99734c13.png";